import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, NFTItem } from '@/components';
import { useNFTName } from '@/contexts';
import { useERC721TokensByIds } from '@/hooks';
import { useLocales } from '../useLocales';
import styles from './index.module.less';
export const ShareBox = ({ nftAddress, nftIds = [], tokens, onShare, ...rest }) => {
    const t = useLocales();
    const nftName = useNFTName(nftAddress);
    const { tokens: tokensByIds } = useERC721TokensByIds(nftAddress, nftIds);
    return (_jsxs(Dialog, { className: styles.shareBox, title: t('Successful'), ...rest, children: [_jsx("ul", { className: styles.nftList, children: (tokens ?? tokensByIds).map((token) => (_jsx("li", { className: styles.item, children: _jsx(NFTItem, { contractName: nftName, token: token }) }, token.tokenId))) }), _jsx("div", { className: styles.buttonGroup, children: _jsx(Button, { className: styles.button, fullWidth: true, colorScheme: "primary", size: "middle", onClick: onShare, children: t('Share to twitter') }) })] }));
};
